import type { QuantitySelectionProps } from './QuantitySelection';

type RequiredQuantitySelectionProps = Required<QuantitySelectionProps>;

export const getValidValues = ({ max, min, step }: RequiredQuantitySelectionProps) => {
  const roundedStep = Math.round(step);
  const roundedMin = Math.round(min);
  const roundedMax = Math.round(max);

  const validStep = roundedStep < 1 ? 1 : roundedStep;
  const validMin = roundedMin < 1 ? 1 : roundedMin;
  const validMax = roundedMax <= roundedMin ? roundedMin + validStep : roundedMax;

  return {
    step: validStep,
    min: validMin,
    max: validMax,
  };
};

type GetValidQuantityProps = {
  currentQuantity: number;
  type: 'decrease' | 'increase';
  values: Omit<RequiredQuantitySelectionProps, 'quantity'>;
};

export const getValidQuantity = ({
  currentQuantity,
  type,
  values,
}: GetValidQuantityProps): number => {
  let quantity = currentQuantity;

  switch (type) {
    case 'increase':
      if (currentQuantity + values.step > values.max) {
        quantity = values.max;
      } else if (currentQuantity < values.max) {
        quantity = currentQuantity + values.step;
      }
      break;
    case 'decrease':
      if (currentQuantity - values.step < values.min) {
        quantity = values.min;
      } else if (currentQuantity > values.min) {
        quantity = currentQuantity - values.step;
      }
      break;
    default:
      throw new Error('Please use a correct type.');
  }

  return quantity;
};
